import * as React from "react";

const AuthAction = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const continueUrlParam = urlParams.get("continueUrl");

  React.useEffect(() => {
    const callback = setTimeout(() => {
      window.location.href = continueUrlParam + window.location.search;
    }, 1000);

    return () => clearTimeout(callback);
    //eslint-disable-next-line
  }, []);

  return <div />;
};

export default AuthAction;
